module.exports = "https://cdn.realtymogul.com/static/media/Marco_A.ae563df1.jpg";